import { Application } from 'types';
import { Timestamp } from "firebase/firestore";

export const getDisplayName = ({ firstName, lastName }: Application) => {
  return `${firstName} ${lastName}`;
};
export const isNewReferrer = (applicationCount?: number): boolean => {
  return (applicationCount ?? 0) === 0;
};

/**
 * Determine if a referrer is active
 * Active if:
 *   - No pending applications, OR
 *   - Has pending applications but last update within 7 days
 * @param pendingApplicationCount number of pending applications
 * @param lastReferredDate last time referrer updated an application (optional)
 * @returns boolean
 */
export const isActiveReferrer = (
  pendingApplicationCount?: number,
  lastReferredDate?: Timestamp
): boolean => {
  // no pending applications → active
  if (!pendingApplicationCount || pendingApplicationCount <= 0) return true;

  const now = Timestamp.now();
  const lastUpdate = lastReferredDate ?? Timestamp.fromMillis(0); // fallback to epoch if missing
  const daysDifference =
    (now.toDate().getTime() - lastUpdate.toDate().getTime()) / (1000 * 3600 * 24);

  // active if last update within 7 days
  return daysDifference <= 7;
};